import { verifySessionToken } from './session';

interface ResolveResult { session: any | null }

// Phase 4: legacy AES tokens removed. Only modern signed tokens are accepted.
export async function resolveSession(raw: string | undefined, clientID: number): Promise<ResolveResult> {
  if (!raw) return { session: null };
  try {
    const session = await verifySessionToken(raw);
    if (session.sub && +session.sub !== +clientID) throw new Error('client_mismatch');
    return { session };
  } catch {
    return { session: null };
  }
}
